import _ from "lodash";

export default {
	inject: ["companySvc", "memberSvc", "reportSvc"],
	methods: {
		async onSwitchStatus(
			type,
			resource,
			status,
			evt = undefined,
			hasConfirm = true
		) {
			if (evt) evt.preventDefault();

			if (hasConfirm) {
				const question = await this.$swal({
					title: "Confirmation",
					text: `Are you sure you want to ${
						"InActive" == status ? "deactivate" : "activate"
					} this ${type}?`,
					type: "warning",
					confirmButtonText: "Okay",
				});

				if (!question.isConfirmed) return false;
			}

			await this.switchStatus(type, resource, status);
		},
        async onSwitchCashCallApproverStatus(
            type,
			resource,
			status,
			evt = undefined,
			hasConfirm = true
		) {
			if (evt) evt.preventDefault();

			if (hasConfirm) {
				const question = await this.$swal({
					title: "Confirmation",
					text: `Are you sure you want to ${
						"InActive" == status ? "remove" : "designate"
					} as cash call approver?`,
					type: "warning",
					confirmButtonText: "Okay",
				});

				if (!question.isConfirmed) return false;
			}

			await this.switchStatus(type, resource, status, true);
		},
		async switchStatus(type, resource, status, cashCallApprover = false) {
			this.$bus.trackEvent("datatable-processing-rows", [resource]);

			var response;

			if ("company" == type) {
				response = await this.companySvc.update({
					id: resource.id,
					name: resource.name || null,
					role_id: resource.role ? resource.role.id : null,
					role_value: resource.role_value || null,
					status: status,
				});

				this.companySvc.set("company", null);
			} else if ("member" == type) {
                if (cashCallApprover === false){
                    if ("Active" === status && !resource.user.is_active) {
                        response = await this.memberSvc.approve({
                            user_id: resource.user.id,
                            status: "Active",
                        });
                    } else {
                        response = await this.memberSvc.update({
                            id: resource.id,
                            company: resource.company ? resource.company.id : null,
                            display_name: resource.user.first_name,
                            status: status,
                            type: resource.type.replace("Company", "Corporate"),
                        });
                    }
                }
                else{
                    response = await this.memberSvc.update({
                            id: resource.id,
                            company: resource.company ? resource.company.id : null,
                            display_name: resource.user.first_name,
                            cash_call_approver: status,
                            type: resource.type.replace("Company", "Corporate"),
                        });
                }


				this.memberSvc.set("member", null);
			} else if ("report" == type) {
				response = await this.reportSvc.update({
					id: resource.id,
					display_name: resource.display_name,
					exportable: status,
				});

				this.reportSvc.set("report", null);
			}

			const success = 200 == response.data.data.status;

			this.$toasted.show(
				success
					? `${_.capitalize(type)} status updated successfully.`
					: `${_.capitalize(type)} status update failed.`,
				{
					type: success ? "success" : "danger",
				}
			);

			this.$bus.trackEvent("datatable-processing-rows", []);
		},
	},
};
